import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    flex: '1 0 auto',
    height: '100%',
    width: '100%',
    maxHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: 0,
    paddingTop: /* eslint-disable-line local-rules/use-theme-tokens */ '24px',
  },
  subContainer: {
    flex: '1 0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  imageContainer: {
    flex: '0 1 auto',
    overflow: 'hidden',
    marginBottom: 0,
  },
  contestContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    flex: '1 1 auto',
    marginBottom: 0,
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ '50px',
    width: '100%',
    textAlign: 'center',

    '& > *': {
      width: '100%',
      maxWidth: '358px',
    },
  },
  coverImage: {
    maxWidth: '400px',
    width: '100%',
    height: 'auto',
  },
}));

export default useStyles;
